import React, { PureComponent } from 'react';

import StateLozenge from 'src/sections/repository/sections/pull-request/components/state-lozenge';

import { DetailedBranchPullRequest } from '../types';

import * as styles from './pull-request-short-row.styled';

type Props = {
  pullRequest: DetailedBranchPullRequest;
  hideTitle?: boolean;
};

export default class PullRequestShortRow extends PureComponent<Props> {
  static defaultProps = {
    hideTitle: false,
  };

  render() {
    const { pullRequest, hideTitle } = this.props;

    return (
      <styles.PullRequestShortRow>
        <styles.PullRequestId>
          <styles.PullRequestLink
            title={pullRequest.title}
            href={pullRequest.links.html.href}
          >
            #{pullRequest.id}
          </styles.PullRequestLink>
        </styles.PullRequestId>

        <styles.PullRequestState>
          <StateLozenge
            pullRequestState={pullRequest.state}
            pullRequestDraft={pullRequest.draft}
            pullRequestCreatedOn={pullRequest.created_on}
            pullRequestClosedOn={pullRequest.closed_on}
          />
        </styles.PullRequestState>

        {!hideTitle && (
          <styles.PullRequestTitle>
            <styles.PullRequestLink
              title={pullRequest.title}
              href={pullRequest.links.html.href}
            >
              {pullRequest.title}
            </styles.PullRequestLink>
          </styles.PullRequestTitle>
        )}
      </styles.PullRequestShortRow>
    );
  }
}
